import React from 'react'

function Spa() {
  return (
    <div>Spa</div>
  )
}

export default Spa